import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SignIn } from "@/app/components/SignIn";

const searchSchema = z.object({
  from: z.string().optional(),
});

export const Route = createFileRoute("/auth/signin")({
  component: SignIn,
  validateSearch: searchSchema,
});
